import { Button, Modal } from "antd";
import React, { useState, useCallback, useEffect, useContext, useMemo } from "react";
import styles from "./index.module.less";
import SearchList from "@/components/ThirdApp/components/ModalAppTool/Search/SearchList";
import ToolsSearch from "@/components/ThirdApp/components/ModalAppTool/Search/Search";
import LeftToolsNav from "@/components/ThirdApp/components/ModalAppTool/LeftToolsNav";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import RightToolsContent from "@/components/ThirdApp/components/ModalAppTool/RightToolsContent";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import { omit, pick } from "lodash";
import { FavoriteType, TopType } from "@/services/AppStore";
import {
  getRoutePathByRole,
  getPcSideConfig,
  PC_SIDE_ITEM_MAX,
  PC_SIDEBAR_KEY
} from "@/utils/tools";
import { ThirdAppSceneType } from "@/types/common";

function ThirdAppListModal(props: any) {
  const { authInfo, appRuntimeEnv, service } = useContext<GlobalContextConfig>(GlobalContext);
  const {
    navPopInfo,
    updateNavPopInfo,
    locks = [],
    selects = [],
    teamConfig,
    pcFuncInfoMap
  } = props;
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [groupId, setGroupId] = useState<string>("");
  const [groups, setGroups] = useState<any>([]);

  const onTabChange = useCallback((groupId: string) => {
    setGroupId(groupId);
  }, []);

  // 基础能力
  const mainApps = useMemo(() => {
    const config = getPcSideConfig(teamConfig, {
      pKey: PC_SIDEBAR_KEY,
      getDefault: false
    });
    const { items = [], otherItems = [] } = config || {};
    console.log(`tj:>>>mainApps`, items);
    const apps = items
      .concat(otherItems)
      .filter((item: any) => !!item.role)
      .map((item: any) => {
        const data = pcFuncInfoMap?.get?.(item.name);
        return {
          ...item,
          name: data?.name || appRuntimeEnv.getI18N(item.name),
          applicationId: item.name,
          iconfont: item.name === "layout.nav.homePage" ? "iconshouye" : item.icon,
          icon: data.icon,
          svg: data.svg,
          isMainApp: true,
          uuid: item.name,
          path: item.path || getRoutePathByRole(item.role || "")
        };
      });
    return {
      applicationScenes: apps,
      groupId: "main",
      name: "核心应用"
    };
  }, [appRuntimeEnv, pcFuncInfoMap, teamConfig]);

  const getAppListAll = useCallback(async () => {
    let result: any = await service.appStoreService.getGroupApplicationScenes({
      sceneType: ThirdAppSceneType.NAVBAR
    });
    const res = result?.groupApplicationScenes || [];
    setGroups([mainApps, ...res]);
    setGroupId(mainApps?.groupId);
  }, [service.appStoreService, mainApps]);

  const isLimit = useMemo(() => {
    return selects?.length >= PC_SIDE_ITEM_MAX;
  }, [selects?.length]);

  const rightContentList = useMemo(() => {
    const group = groups?.length ? groups.find((item: any) => item.groupId === groupId) : {};
    const res = (group?.applicationScenes || []).map((app: any) => {
      const exist = selects.find(
        // 237 场景id, 兼容无sceneId的老数据
        (i: any) => {
          const res =
            (i.sceneId && i.sceneId === app.sceneId) ||
            (!i.sceneId && i.applicationId === app.applicationId) ||
            (!i.sceneId && i.name === app.applicationId);
          return res;
        }
      );
      const isTop = locks.includes(app.sceneId);
      return {
        ...app,
        favorite: exist ? FavoriteType.FavoriteYes : FavoriteType.FavoriteNo,
        topType: exist && isTop ? TopType.TopYes : TopType.TopNo,
        disabled: !exist && isLimit,
        uuid: app.uuid || `${app.applicationId}_${app.sceneId}`
      };
    });
    return res;
  }, [groupId, groups, locks, selects, isLimit]);

  const handleCancel = useCallback(() => {
    updateNavPopInfo({
      appModalShow: false
    });
  }, [updateNavPopInfo]);

  useEffect(() => {
    getAppListAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdd = useCallback(
    (item: any) => {
      const pcSide = navPopInfo?.pcSide || {};
      if (!pcSide?.items) {
        pcSide.items = [];
      }
      if (!item.isMainApp) {
        const uuid = `${item.applicationId}_${item.sceneId}`;
        const i: any = {
          ...pick(item, [
            "applicationId",
            "icon",
            "applicationKey",
            "sceneId",
            "uuid",
            "homeUrl",
            "openType"
          ]),
          name: item.uuid || uuid,
          avatar: item.icon,
          cnName: item.name,
          uuid: item.uuid || uuid
        };
        if (item.svg) {
          i.svg = item.svg;
        }
        pcSide.items.push(i);
      } else {
        pcSide.items.push(
          omit(
            {
              ...item,
              name: item.applicationId,
              cnName: item.name,
              icon: item.iconfont || item.iconfont
            },
            ["applicationId"]
          )
        );
      }
      updateNavPopInfo({
        pcSide: { ...pcSide }
      });
    },
    [navPopInfo?.pcSide, updateNavPopInfo]
  );

  const handleDelete = useCallback(
    (item: any) => {
      const pcSide = navPopInfo?.pcSide || {};
      if (!pcSide?.items) {
        pcSide.items = [];
      }
      pcSide.items = pcSide.items.filter(
        (i: any) =>
          ((i.sceneId && i.sceneId !== item.sceneId) ||
            (!i.sceneId && i.applicationId !== item.applicationId)) &&
          i.name !== item.applicationId
      );
      updateNavPopInfo({
        pcSide: { ...pcSide }
      });
    },
    [navPopInfo?.pcSide, updateNavPopInfo]
  );

  const footerComp = useMemo(() => {
    return (
      <div>
        <Button type="primary" onClick={handleCancel}>{`选择(${selects?.length || 0}/21)`}</Button>
      </div>
    );
  }, [selects?.length]);

  return (
    <Modal
      className={styles["third-app-modal"]}
      bodyStyle={{ minHeight: 300, padding: 0 }}
      title="添加应用"
      destroyOnClose={true}
      maskClosable={false}
      visible={navPopInfo?.appModalShow}
      centered
      onCancel={handleCancel}
      footer={footerComp}
    >
      <div>
        <div className="tools-modal-search">
          <div className="top-left-box">
            {/* <div className="tools-search-box">
              <ToolsSearch
                onShowToolsSearch={(isShow: boolean) => {
                  setShowSearch(isShow);
                }}
              />
            </div> */}
          </div>
        </div>
        <div className="app-tools-main" style={{ display: showSearch ? "none" : "flex" }}>
          <LeftToolsNav leftNavList={groups} onTabChange={onTabChange} />
          <RightToolsContent
            isPointer={false}
            rightContentList={rightContentList}
            addFavText="添加"
            deleteFavText="取消"
            onAdd={handleAdd}
            onDelete={handleDelete}
          />
        </div>
      </div>
    </Modal>
  );
}

function mapStateToProps({ user }: { user: UserState }) {
  return {
    navPopInfo: user.navPopInfo,
    teamConfig: user.teamConfig,
    pcFuncInfoMap: user.pcFuncInfoMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateNavPopInfo(payload: any) {
      dispatch({ type: "user/updateNavPopInfo", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdAppListModal);
